module.exports = __webpack_public_path__ + "4b512aac36326c5c9b1a76181a27a379.png";